import React from 'react';
import PreFormValidateDni from '../../../../../common/PreFormValidateDni';
import { useLocation } from 'react-router-dom';

const PreFormChangeEmail = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const motiveId = params.get('motiveId');

  return (
    <PreFormValidateDni mobile motiveId={motiveId} issueForm={'ChangeEmail'} />
  );
};

export default PreFormChangeEmail;
